import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { Core } from "../../components/infrastructure/core";
import { City } from "../city";
import { ICityProps } from "../city/interfaces";
import { enmPersonalityTypes } from "../center/interfaces";
import { Insurer } from "../insurer";
import { Province } from "../province";
import { UserRelation } from "../userRelation";
import { IPolicyholder, IPolicyholderProps, IPolicyholderStates } from "./interfaces";
import { FormInstance } from "antd";

export class Policyholder extends EntityManager<IPolicyholder, IPolicyholderProps, IPolicyholderStates>{
    userPolicyholderFormId: string;
    userPolicyholder?: UserRelation | null;
    static initMetadata = (): IMetadata => {
        return {
            name: "Policyholder",
            title: "بیمه گزار/مشتری",
            Properties: [
                {
                    title: "بیمه گر",
                    dataIndex: "InsurerId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا بیمه گر را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Insurer,
                        lookupProperty: "Insurer",
                        lookupDisplayFields: ["Name"]
                    },
                    showInLookup: false
                },
                {
                    title: "کد بیمه گزار/مشتری",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "نوع بیمه گزار/مشتری",
                    dataIndex: "Personality",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        options: [
                            { title: 'حقیقی', value: enmPersonalityTypes.Actual },
                            { title: 'حقوقی', value: enmPersonalityTypes.Legal }
                        ]
                    },
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نوع مرکز را تعیین نمایید' }],
                    showInLookup: false
                },
                {
                    title: "کد/شناسه ملی",
                    dataIndex: "NationalCode",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد/شناسه ملی بیمه گزار/مشتری را وارد نمایید' }]
                },
                {
                    title: "نام شرکت",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rulesFunc: (entity: IPolicyholder) => {
                        if (entity.Personality === enmPersonalityTypes.Legal) {
                            return [{ required: true, message: 'لطفا نام شرکت بیمه گزار/مشتری را وارد نمایید' }];
                        }
                    },
                    visibility: (entity: IPolicyholder) => {
                        return entity.Personality === enmPersonalityTypes.Legal;
                    },
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "نام",
                    dataIndex: "FirstName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rulesFunc: (entity: IPolicyholder) => {
                        if (entity.Personality === enmPersonalityTypes.Actual) {
                            return [{ required: true, message: 'لطفا نام بیمه گزار/مشتری را وارد نمایید' }];
                        }
                    },
                    visibility: (entity: IPolicyholder) => {
                        return entity.Personality === enmPersonalityTypes.Actual;
                    },
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "نام خانوادگی",
                    dataIndex: "LastName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rulesFunc: (entity: IPolicyholder) => {
                        if (entity.Personality === enmPersonalityTypes.Actual) {
                            return [{ required: true, message: 'لطفا نام خانوادگی بیمه گزار/مشتری را وارد نمایید' }];
                        }
                    },
                    visibility: (entity: IPolicyholder) => {
                        return entity.Personality === enmPersonalityTypes.Actual;
                    },
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "تاریخ تولد",
                    dataIndex: "BirthDate",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    filterable: true,
                    width: 150,
                    rulesFunc: (entity: IPolicyholder) => {
                        if (entity.Personality === enmPersonalityTypes.Actual) {
                            return [{ required: true, message: 'لطفا تاریخ تولد بیمه گزار/مشتری را وارد نمایید' }];
                        }
                    },
                    visibility: (entity: IPolicyholder) => {
                        return entity.Personality === enmPersonalityTypes.Actual;
                    },
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "نام بیمه گزار/مشتری",
                    dataIndex: "FullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    width: 150,
                    showControl: false,
                    sortable: false
                },
                {
                    title: "استان",
                    dataIndex: "ProvinceId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    lookup: {
                        lookupComponent: Province,
                        lookupProperty: "Province",
                        lookupDisplayFields: ["Name"],
                        dropdownDisplayFields: ["Name"]
                    },
                    showInLookup: false
                },
                {
                    title: "شهر",
                    dataIndex: "CityId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    lookup: {
                        lookupComponent: City,
                        lookupProperty: "City",
                        lookupDisplayFields: ["Name"],
                        dropdownDisplayFields: ["Name"]
                    },
                    showInLookup: false
                },
                {
                    title: "آدرس",
                    dataIndex: "Address",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "شماره همراه",
                    dataIndex: "Phone",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.numberinput,
                    formatter: value => {
                        const formated = `${value}`.length ? `0${value}`.replace(/\D+/g, '') : "";
                        return formated;
                    },
                    parser: value => {
                        const parsed = (value && value.length && value.startsWith('0') ? value.substring(1) : value) ?? "";
                        return parsed;
                    },
                    onKeyPress: (event, value) => {
                        if (!event.key.match(/\d/g) || `${value}`.length >= 10) {
                            event.preventDefault();
                        }
                    },
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "نشانی الکترونیک",
                    dataIndex: "Email",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.email,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                }
            ]
        };
    }
    constructor(props: IPolicyholderProps) {
        super(props)
        this.userPolicyholderFormId = Core.newId();
    }
    onInitializing() {
        this.searchable = true;

        this.searchArea = {
            columnsPerRow: 2,
            onFilterChanged: (property, _, form) => {
                if (property.dataIndex === "ProvinceId") {
                    form?.resetFields(["CityId"]);
                    form?.setFields([{ name: "CityId", value: null }]);
                }
            }
        };



        this.preparelookupProps = (propName, lookupProps: any, form, isSearchForm) => {
            if (propName === "CityId")
                (lookupProps as ICityProps).params = () => {
                    let province = isSearchForm && form ? form.getFieldValue("ProvinceId") : this.state.currentEntity?.Province;
                    if (isSearchForm && form)
                        return { province: province?.value };
                    else
                        return { province };
                };

            return lookupProps;
        };

        this.onEntityAdded = (entity) => {
            entity.Personality = enmPersonalityTypes.Actual;
            entity.BirthDate = undefined;
            entity.ModifiedProperties.push("Personality");
            return true;
        };

        this.onEntityChanged = (entity: IPolicyholder, propertyName: string, form: FormInstance<any>) => {
            if (propertyName === "Personality") {
                form.setFields([{ name: "BirthDate", value: undefined }]);
                entity.BirthDate = undefined;
            }
            if (propertyName === "ProvinceId") {
                form.resetFields(["CityId"]);
                form.setFields([{ name: "CityId", value: null }]);
                entity.City = undefined;
                entity.CityId = 0;
            }
            if (propertyName === "CityId") {
                if (!entity.Province) {
                    form.resetFields(["ProvinceId"]);
                    form.setFields([{ name: "ProvinceId", value: entity.City?.Province }]);
                    entity.Province = entity.City?.Province;
                    entity.ProvinceId = entity.City?.ParentId ?? 0;
                }
            }
        };
    }
    onUsersClick = () => {
        this.setState({ displayLookupForm: this.userPolicyholderFormId });
        this.userPolicyholder?.fetchData();
    }
}